import {Component, OnInit, ViewChild} from '@angular/core';
import {TiendaServices} from '../../CoreModule/services/tienda.services';
import {ReporteServices} from '../services/reporte.services';
import {NgxSpinnerService} from 'ngx-spinner';
import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {EstadoWidgetComponent} from './widgets/estado.widget.component';
import * as moment from 'moment';
import {VentasComparativoWidgetComponent} from './widgets/ventas.comparativo.widget.component';
import {ParticipacionWidgetComponent} from './widgets/participacion.widget.component';
import {IndicadoresComparativoWidgetComponent} from './widgets/indicadores.comparativo.widget.component';
import {SemanaServices} from '../../FriedmanModule/services/semana.services';
import {CategoriasWidgetComponent} from './widgets/categorias.widget.component';
import {TypeaheadMatch} from 'ngx-bootstrap';

@Component({
  selector: 'reporte-comp-dashboard',
  templateUrl: '../templates/reporte.comparativo.dashboard.template.html',
  styleUrls: ['../styles/reporte.dashboard.comparativo.styles.scss']
})
export class ReporteComparativoDashboardComponent implements OnInit {

  public tiendas: TiendaEntity[] = [];
  public tiendaSelect: TiendaEntity;
  public tSelectName:string = "";

  public fecha1: string = '2019-05-06';
  public fecha2: string = '2019-05-12';
  public fecha3: string = '2019-05-13';
  public fecha4: string = '2019-05-19';

  // public fecha1: string = '';
  // public fecha2: string = '';
  // public fecha3: string = '';
  // public fecha4: string = '';

  public tituloReport1: string = '';
  public tituloReport2: string = '';

  opcSem: any[] = [];
  opcMes: any[] = [];
  public semSelect1: any;
  public semSelect2: any;
  public mesSelect1: number;
  public trimSelect1: number;
  public semesSelect1: number;
  public anoSelect1: number = 2019;

  public mesSelect2: number;
  public trimSelect2: number;
  public semesSelect2: number;
  public anoSelect2: number = 2019;

  public verSec: number = 0;


  @ViewChild('estado1', { static: true })
  private rEstado1: EstadoWidgetComponent;

  @ViewChild('estado2', { static: true })
  private rEstado2: EstadoWidgetComponent;

  @ViewChild(VentasComparativoWidgetComponent, { static: true })
  private rVentas: VentasComparativoWidgetComponent;

  @ViewChild(IndicadoresComparativoWidgetComponent, { static: true })
  private rIndi: IndicadoresComparativoWidgetComponent;


  @ViewChild('par1', { static: true })
  private rPar1: ParticipacionWidgetComponent;

  @ViewChild('par2', { static: true })
  private rPar2: ParticipacionWidgetComponent;

  @ViewChild('cat1', { static: true })
  private rCat1: CategoriasWidgetComponent;

  @ViewChild('cat2', { static: true })
  private rCat2: CategoriasWidgetComponent;

  constructor(private ts: TiendaServices, private rs: ReporteServices, private spinner: NgxSpinnerService, private  ss: SemanaServices) {

  }

  ngOnInit(): void {
    for (let j = 1; j < 53; j++) {
      this.opcSem.push(j);
    }

    this.opcMes.push({mes: 'Enero', val: 1});
    this.opcMes.push({mes: 'Febrero', val: 2});
    this.opcMes.push({mes: 'Marzo', val: 3});
    this.opcMes.push({mes: 'Abril', val: 4});
    this.opcMes.push({mes: 'Mayo', val: 5});
    this.opcMes.push({mes: 'Junio', val: 6});
    this.opcMes.push({mes: 'Julio', val: 7});
    this.opcMes.push({mes: 'Agosto', val: 8});
    this.opcMes.push({mes: 'Septiembre', val: 9});
    this.opcMes.push({mes: 'Octubre', val: 10});
    this.opcMes.push({mes: 'Noviembre', val: 11});
    this.opcMes.push({mes: 'Diciembre', val: 12});


    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
      this.spinner.hide();
      this.tiendaSelect = this.tiendas[0];
      this.tSelectName = this.tiendaSelect.nombre;
    });
  }

  tiendaSeleccionada(event:TypeaheadMatch){
    this.tiendaSelect = event.item;
  }

  consultarDatos() {
    this.verSec = 0;
    if (this.tiendaSelect) {
      let fechaIni1 = moment(this.fecha1);
      let fechaFin1 = moment(this.fecha2);
      let fechaIni2 = moment(this.fecha3);
      let fechaFin2 = moment(this.fecha4);
      this.tituloReport1 = `Reporte de estado del ${this.fecha1} al ${this.fecha2}`;
      this.tituloReport2 = `Reporte de estado del ${this.fecha3} al ${this.fecha4}`;

      this.rEstado1.consultar(4, this.tiendaSelect.id, fechaIni1.format('YYYY-MM-DD'), fechaFin1.format('YYYY-MM-DD'));
      this.rEstado2.consultar(4, this.tiendaSelect.id, fechaIni2.format('YYYY-MM-DD'), fechaFin2.format('YYYY-MM-DD'));
      this.rVentas.consultar(4, this.tiendaSelect.id, fechaIni1.format('YYYY-MM-DD'), fechaFin1.format('YYYY-MM-DD'), fechaIni2.format('YYYY-MM-DD'), fechaFin2.format('YYYY-MM-DD'));
      this.rIndi.consultar(4, this.tiendaSelect.id, fechaIni1.format('YYYY-MM-DD'), fechaFin1.format('YYYY-MM-DD'), fechaIni2.format('YYYY-MM-DD'), fechaFin2.format('YYYY-MM-DD'));

      this.rPar1.consultar(4, this.tiendaSelect.id, fechaIni1.format('YYYY-MM-DD'), fechaFin1.format('YYYY-MM-DD'));
      this.rPar2.consultar(4, this.tiendaSelect.id, fechaIni2.format('YYYY-MM-DD'), fechaFin2.format('YYYY-MM-DD'));
      this.rCat1.consultar(4, this.tiendaSelect.id, fechaIni1.format('YYYY-MM-DD'), fechaFin1.format('YYYY-MM-DD'));
      this.rCat2.consultar(4, this.tiendaSelect.id, fechaIni2.format('YYYY-MM-DD'), fechaFin2.format('YYYY-MM-DD'));
    }
  }

  consultarSemana() {
    if (this.verSec != 2) {
      this.verSec = 2;
      return;
    }

    if (!this.semSelect1) {
      alert('Seleccione la semana del periodo 1');
      return;
    }

    if (!this.semSelect2) {
      alert('Seleccione la semana del periodo 2');
      return;
    }

    let ano = moment().year();
    this.ss.devolverPrimerDia(ano).subscribe(d => {
      console.log(d);

      let primerDia = d.data.ano.primerDia;

      this.fecha1 = moment(primerDia, 'YYYY-MM-DD').add(this.semSelect1 - 1, 'w').format('YYYY-MM-DD');
      this.fecha2 = moment(this.fecha1, 'YYYY-MM-DD').add(6, 'd').format('YYYY-MM-DD');

      this.fecha3 = moment(primerDia, 'YYYY-MM-DD').add(this.semSelect2 - 1, 'w').format('YYYY-MM-DD');
      this.fecha4 = moment(this.fecha3, 'YYYY-MM-DD').add(6, 'd').format('YYYY-MM-DD');

      this.consultarDatos();

    });
  }

  consultarMes() {
    if (this.verSec != 3) {
      this.verSec = 3;
      return;
    }
    if (!this.mesSelect1) {
      alert('Seleccione el mes del periodo 1');
      return;
    }

    if (!this.mesSelect2) {
      alert('Seleccione el nes del periodo 2');
      return;
    }

    console.log(this.mesSelect1);
    console.log(this.mesSelect2);

    this.fecha1 = moment().date(1).month(this.mesSelect1-1).hour(0).minute(0).format('YYYY-MM-DD');

    let f2 = moment(this.fecha1, 'YYYY-MM-DD').add(1, 'M');
    f2.subtract(1,'d');
    this.fecha2 = f2.format('YYYY-MM-DD');

    this.fecha3 = moment().date(1).month(this.mesSelect2-1).hour(0).minute(0).format('YYYY-MM-DD');
    let f3 = moment(this.fecha3, 'YYYY-MM-DD').add(1, 'M');
    f3.subtract(1,'d');
    this.fecha4 = f3.format('YYYY-MM-DD');

    this.consultarDatos();
  }

  consultarTrimestre() {

    if (this.verSec != 2) {
      this.verSec = 2;
      return;
    }


    // let opc = +this.trimSelect1;

  }

  consultarSemestre() {
    if (this.verSec != 3) {
      this.verSec = 3;
      return;
    }

  }

  consultarAnual() {
    if (this.verSec != 4) {
      this.verSec = 4;
      return;
    }
  }

  consultarFechas() {
    this.verSec = 1;
  }

  consultarHoy() {
    if (this.verSec != 0) {
      this.verSec = 0;
      return;
    }
  }
}
